import { fabric } from 'fabric';

// A guide that shows alignment between objects
class GuideAlign extends fabric.Line {
  type = 'guideAlign';

  _render(ctx: CanvasRenderingContext2D) {
    if (this.canvas.exporting) return;

    super._render(ctx);
  }
}

export default GuideAlign;
